import { createRoot } from 'react-dom/client';
import { ScaWrapperPage } from './sca-wrapper-page';

const container = document.querySelector('#root');

if (!container) {
  throw new Error('Root element "#root" not found in DOM');
}

createRoot(container).render(<ScaWrapperPage />);
